 const scrollDown = () => {
    if(document.getElementById('stoof-scroll-down')){

        document.addEventListener('click', ev => {
            if(!ev.target.closest('#stoof-scroll-down')) return;
            ev.preventDefault();
            let pageHeight = window.innerHeight;
            let scrollLess = 0;
            if(document.querySelector('.stoof-scroll-to-content__not-full-hero')){
               scrollLess = pageHeight/3;
            }
            const header = document.querySelector('.stoof-navbar');
            let headerHeight = 0;
            if (typeof header !== 'undefined') {
                headerHeight = header.offsetHeight;
            }

            //window.scrollBy(0, pageHeight - scrollLess);
            window.scrollBy({
                top: pageHeight - scrollLess - headerHeight,
                left: 0,
                behavior: 'smooth'
            });
        })
    }
}
 export default scrollDown;